class FitProfile {
  constructor({
    birthYear,
    chest,
    height,
    inseam,
    jacketLength,
    measuredAt,
    neck,
    preferredFit,
    shoe,
    shoulderShape,
    sleeve,
    stomachShape,
    waist,
    weight,
  }) {
    this.birthYear = birthYear
    this.chest = chest
    this.height = height
    this.inseam = inseam
    this.jacketLength = jacketLength
    this.measuredAt = measuredAt
    this.neck = neck
    this.preferredFit = preferredFit
    this.shoe = shoe
    this.shoulderShape = shoulderShape
    this.sleeve = sleeve
    this.stomachShape = stomachShape
    this.waist = waist
    this.weight = weight
  }
}

export const EMPTY_FIT_PROFILE = new FitProfile({
  birthYear: undefined,
  chest: undefined,
  height: undefined,
  inseam: undefined,
  jacketLength: undefined,
  measuredAt: undefined,
  neck: undefined,
  preferredFit: undefined,
  shoe: undefined,
  shoulderShape: undefined,
  sleeve: undefined,
  stomachShape: undefined,
  waist: undefined,
  weight: undefined,
})

export default FitProfile
